import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageConfigComponent } from './page-config.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntModule, PositionInConfigModule } from 'vhobjects-service';
import { ColorPickerModule } from 'ngx-color-picker';
import { VhStringPercentPipeModule } from '../vhstringpercent.pipe';
import { BackgroundImageConfigModule } from 'vhobjects-service';
import { BordersConfigModule } from 'vhobjects-service';
import { TranslateModule } from '@ngx-translate/core';
import { BordersRadiusConfigModule } from 'vhobjects-service';
import { AnimationsConfigModule } from 'vhobjects-service';
import { ChooseAnimationsConfigModule } from 'vhobjects-service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';



@NgModule({
  declarations: [PageConfigComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgZorroAntModule,
    ReactiveFormsModule,
    ColorPickerModule,
    VhStringPercentPipeModule,
    BackgroundImageConfigModule,
    BordersConfigModule,
    TranslateModule,
    BordersRadiusConfigModule,
    AnimationsConfigModule,
    ChooseAnimationsConfigModule,
    PositionInConfigModule

  ],
  exports: [PageConfigComponent],
  providers: [{ provide: MAT_DIALOG_DATA, useValue: {} }]
})
export class PageConfigModule { }
